import React, { useState } from "react";
import { Space, List, Collapse } from "antd";
import {
    showTotalForTinyScreen,
    showTotalForLargeScreen,
} from "./ResponsiveTotals";
import useResponsiveScreen from "@Src/hooks/useResponsiveScreen";

import "./ResolutionList.less";
import EstimatedTotal from "../Footers/EstimatedTotal";

const { Panel } = Collapse;

const ResolutionList = (props: any): React.JSX.Element => {
    const {
        resolutionList,
        totalPrice,
        isReadOnly,
        readOnlyFooterDetail,
        resolutionListRenderItem,
        additionalFooter,
        allowCollapse,
        collapsePanelHeader,
        keyValue,
    } = props;

    const [currentPage, setCurrentPage] = useState(1);

    const pageSize = 5;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handlePageChange = (page: number, pageSize: number): void => {
        setCurrentPage(page);
    };

    const renderItemWithAbsoluteIndex = (
        item: any,
        index: number
    ): React.ReactNode => {
        const absoluteIndex = (currentPage - 1) * pageSize + index;
        return resolutionListRenderItem(item, absoluteIndex);
    };

    const footer = (
        <>
            <Space
                size={0}
                className={`${
                    additionalFooter ? "suppress-bottom-padding" : ""
                }`}
            >
                {!isReadOnly && <EstimatedTotal totalPrice={totalPrice} />}
                {isReadOnly && readOnlyFooterDetail}
            </Space>
            {additionalFooter?.()}
        </>
    );

    const { isXxs, isXs, isMd } = useResponsiveScreen();

    return (
        <>
            {allowCollapse && (
                <div className="item-resolution-list">
                    <Collapse defaultActiveKey={["0"]}>
                        <Panel header={collapsePanelHeader} key="1">
                            <List
                                className="item-resolution-list"
                                itemLayout="vertical"
                                pagination={
                                    resolutionList.length > pageSize && {
                                        showTotal: (
                                            total,
                                            range
                                        ): React.ReactNode => {
                                            if (isXxs || isXs) {
                                                return showTotalForTinyScreen();
                                            } else {
                                                return showTotalForLargeScreen(
                                                    total,
                                                    range
                                                );
                                            }
                                        },
                                        pageSize: pageSize,
                                        current: currentPage,
                                        total: resolutionList.length,
                                        size: "small",
                                        showSizeChanger: false,
                                        responsive: true,
                                        simple: isXs || isXxs,
                                        showLessItems: !isMd,
                                        onChange: handlePageChange,
                                    }
                                }
                                dataSource={resolutionList.slice(
                                    (currentPage - 1) * pageSize,
                                    currentPage * pageSize
                                )}
                                renderItem={renderItemWithAbsoluteIndex}
                                key={keyValue}
                            />
                        </Panel>
                    </Collapse>
                    <div className="ant-list-footer">{footer}</div>
                </div>
            )}
            {!allowCollapse && (
                <List
                    className="item-resolution-list"
                    itemLayout="vertical"
                    pagination={
                        resolutionList.length > 5 && {
                            showTotal: (total, range): React.ReactNode => {
                                if (isXxs || isXs) {
                                    return showTotalForTinyScreen();
                                } else {
                                    return showTotalForLargeScreen(
                                        total,
                                        range
                                    );
                                }
                            },
                            pageSize: 5,
                            total: resolutionList.length,
                            size: "small",
                            showSizeChanger: false,
                            responsive: true,
                            simple: isXs || isXxs,
                            showLessItems: !isMd,
                            onChange: handlePageChange,
                        }
                    }
                    dataSource={resolutionList.slice(
                        (currentPage - 1) * pageSize,
                        currentPage * pageSize
                    )}
                    renderItem={renderItemWithAbsoluteIndex}
                    footer={footer}
                />
            )}
        </>
    );
};

export default ResolutionList;
